import { render, staticRenderFns } from "./editCommodityDetails.vue?vue&type=template&id=4dc3d388&scoped=true&"
import script from "./editCommodityDetails.vue?vue&type=script&lang=js&"
export * from "./editCommodityDetails.vue?vue&type=script&lang=js&"
import style0 from "./editCommodityDetails.vue?vue&type=style&index=0&id=4dc3d388&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dc3d388",
  null
  
)

export default component.exports